import type { CapKeyDto } from "../../types/CapKeyDto";
import type { CapKeyEntity } from "../../types/CapKeyEntity";

export const CapKeyEntityToDto = ({ ...rest }: Readonly<CapKeyEntity>): CapKeyDto => {
    return { ...rest };
};
